module.exports = __webpack_public_path__ + "img/clock-orange.974b6849.svg";